// Copyright (c) Ping. All rights reserved.
//
// Re-fetch the authenticated user's canonical profile from the server and push
// it into the shared self-profile store (sidebar + chat self-avatar + Settings).
// Used both on Settings open and — crucially for multi-device — when a sibling
// device signals a profile change over the DeviceGroup (`com.ping.self_profile`,
// applied in `useIncomingMessages`), so a name/avatar edit on one device shows
// on the others in realtime instead of only on their next foreground.

import { log } from '@core/log/log';
import { fetchMediaDownloadUrl } from '@features/chat/mediaUpload';
import { useSelfProfile } from '@features/profile/selfProfileStore';
import { getProfile } from '@features/settings/web/profilesApi';

export async function refreshSelfProfileFromServer(): Promise<void> {
  try {
    const profile = await getProfile();
    let avatarUrl: string | null = null;
    if (profile.avatarMediaId !== null) {
      avatarUrl = await fetchMediaDownloadUrl(profile.avatarMediaId).catch(() => null);
    }
    useSelfProfile.getState().setProfile({
      displayName: profile.displayName,
      avatarMediaId: profile.avatarMediaId,
      avatarUrl,
    });
  } catch (err) {
    log.warn({ event: 'profile.refresh.failed', message: (err as Error).message });
  }
}
